export const TipoExame = {
    TesteCovid : "TesteCovid",
    TestesTLR : "TestesTLR" 
}